const { callback: handleNavigate } = require('client/lib/navigate')

const ACTION_EVENT_NAMES = [
  'copy', 'cut', 'focusin', 'focusout', 'keydown', 'paste', 'input',
  'keyup', 'mouseover', 'mouseout', 'mousedown', 'submit'
].join(' ')

module.exports = function (eventHandlers) {
  const $doc = $(document)

  $doc.on('click', '[data-click]', handleClick)
  $doc.on('keydown', '[data-click]', handleKeyDown)
  $doc.on('click', '[data-navigate]', handleNavigate)
  $doc.on(ACTION_EVENT_NAMES, '[data-action]', handleAction)
  $doc.on('click', 'a[target=_blank]', handleExternalHref)

  function handleKeyDown(event) {
    //  13 == enter            32 == space
    if (event.keyCode == 13 || event.keyCode == 32) {
      handleClick.call(this, event)
    }
  }

  function handleClick(event) {
    if (event.isImmediatePropagationStopped()) {
      return
    }
    // let descending links work normally
    let child = event.target
    while (child && child !== this) {
      if (child.href) {
        return
      }
      child = child.parentNode
    }
    $(this).attr('data-click').split(',').forEach(method => {
      const action = eventHandlers[method]
      if (action) {
        action.call(this, event)
      }
    })
  }

  function handleAction(event) {
    if (event.isImmediatePropagationStopped()) {
      return
    }
    $(this).attr('data-action').split(',').forEach(method => {
      const action = eventHandlers[`${event.type}-${method}`]
      if (action) {
        action.call(this, event)
      }
    })
  }

  function handleExternalHref(event) {
    if (event.isImmediatePropagationStopped()) {
      return
    }
    event.preventDefault()
    const href = $(this).attr('href')
    window.open(href)
  }
}
